<template>
  <div class="app-multiselect__list-wrapper">
    <div
      class="app-multiselect__list-container"
      v-if="multiselectRef._props.datalist.length"
    >
      <div class="app-multiselect__header-container">
        <MultiselectSearch :multiselectRef="multiselectRef" />
      </div>

      <div class="app-multiselect__options-list-wrapper">
        <ul
          v-if="datalistFiltered.length"
          class="app-multiselect__options-list"
        >
          <MultiselectListItem
            :key="`multiselect-option-item-${index}`"
            v-for="(item, index) in datalistFiltered"
            :item="item"
            :multiselectRef="multiselectRef"
          />
        </ul>
        <ul v-else class="app-multiselect__options-list">
          <li class="app-multiselect__option-item">
            <div class="app-multiselect__option-item-content">
              <span class="app-multiselect__option-label">{{
                notFoundMessage
              }}</span>
            </div>
          </li>
        </ul>
      </div>

      <div v-if="showFooter" class="app-multiselect__footer-container">
        <MultiselectSelectAllButton
          :multiselectRef="multiselectRef"
          :footerText="footerText"
        />
      </div>
    </div>

    <span class="app-multiselect__empty-list-alert" v-else>
      {{ multiselectRef._props.emptyListAlert }}
    </span>
  </div>
</template>

<script>
import MultiselectSearch from "./MultiselectSearch.vue";
import MultiselectSelectAllButton from "./MultiselectSelectAllButton.vue";
import MultiselectListItem from "./MultiselectListItem.vue";

export default {
  components: {
    MultiselectSearch,
    MultiselectSelectAllButton,
    MultiselectListItem,
  },
  computed: {
    isOpen() {
      return this.multiselectRef._data.isOpen;
    },
    datalistFiltered() {
      return this.multiselectRef._data.datalistFiltered;
    },
  },
  props: {
    multiselectRef: {
      type: Object,
      default: () => {},
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    notFoundMessage: {
      type: String,
      default: "Nenhum resultado encontrado",
    },
    footerText: {
      type: String,
      default: "Selecionar Todos",
    },
  },
};
</script>

<style lang="scss">
.app-multiselect__container {
  .app-multiselect__list-wrapper {
    position: absolute;
    top: calc(100% + 4px);
    padding: 8px 0;
    background-color: #fff;
    width: 100%;
    border-radius: 6px;
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.1);
    z-index: 2;

    .app-multiselect__list-container {
      .app-multiselect__header-container {
        padding: 12px 21px;
      }

      .app-multiselect__options-list-wrapper {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-track {
          background: #fbeee8;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #fbeee8;
          border-radius: 20px;
          border: 3px solid #cfc4be;
        }

        .app-multiselect__options-list {
          display: flex;
          flex-direction: column;
          list-style: none;
          margin: 0;
          padding: 0;
          max-height: 212px;
        }
      }

      .app-multiselect__footer-container {
        padding: 8px 21px;
        display: flex;
        justify-content: center;
      }
    }

    .app-multiselect__empty-list-alert {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #6e6b7b;
      padding: 12px;
    }
  }
}
</style>
